import { Component, Input, OnInit } from '@angular/core';
import { ChartData, ChartOptions, ChartType } from 'chart.js';
import { ApiServiceBase } from 'src/app/Services/api.service.base';

@Component({
    selector: 'app-enforcementserieschart',
    templateUrl: './enforcementserieschart.component.html',
    styleUrls: ['./enforcementserieschart.component.scss'],
    standalone: false
})
export class EnforcementSeriesChartComponent implements OnInit {
    @Input()
    public Title : string = "Violations";
    @Input()
    public Period : string = "today";
    @Input()
    public Schema : string = "enforcement";
    @Input()
    public DataType : string = "inflows";
    @Input()
    public ChartType : string = "line";
    @Input()
    public Height : number = 100;
    @Input()
    public StructureId : string = "all";
    @Input()
    public StructureType : string = "";
    public Url : string= "";
    @Input()
    public ActionedOnly: boolean = false;
  
    public ChartOptions : ChartOptions = {
      elements: {
        line: {
          tension: 0.2
        }
      },
      scales:{
        yAxes:{
          beginAtZero: true,
          ticks: {
            precision : 0
          }
        }
      },
      plugins: {
        legend : { display: false }
      }
    };
    public ChartData : ChartData = {
      datasets: [],
    };
    public ChartColors: string[] = [
      'green'
    ];
  
    constructor(private apiService : ApiServiceBase) { }
  
    ngOnInit(): void {

      this.Url = this.Schema +'/violations/series/' + (this.StructureType != "" ? this.StructureType+ "/" : "") + (this.StructureId != "" ? this.StructureId : "all") + '/' + this.Period + '/' + this.DataType + '/' + this.ActionedOnly
      

      this.apiService.Get<any>(this.Url).then(result => {
        this.ChartData =  {
          datasets: [{
                  data: result.Values,
                  label: 'Violations',
                  pointBackgroundColor: ['green'],
                  pointBorderColor: ['green'],
                  backgroundColor: ['green'],
                  borderColor: ['green']
          }],
          labels: result.Labels,
        };
      });
    }
  }
  
